"use client";

import { Box, Container, Grid2, TextField, Button, Stack } from "@mui/material";
import Breadcrumb from "./Breadcrumb";
import { useState } from "react";
import styles from "./styles.module.css";

export default function Contact() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Handle form submission here in the future
        console.log(formData);
    };

    return (
        <>
            <Box height={80}></Box>
            <Container sx={{ paddingBottom: "4rem" }}>
                <Breadcrumb />
                <Grid2 container spacing={7}>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <h2 className="heading_3r">Medallion Homes</h2>
                        <Box height={100}></Box>
                        <Grid2 container spacing={{ xs: 0, md: 3 }}>
                            <Grid2 size={{ xs: 12, md: 6 }}>
                                <p
                                    className={`${styles.light_text} ${styles.zero_margin_n_padding}`}
                                >
                                    General Inquiries
                                </p>
                            </Grid2>
                            <Grid2 size={{ xs: 12, md: 6 }}>
                                <a
                                    href="mailto:info@medallionhomes.com"
                                    className={`${styles.contact_link} ${styles.zero_margin_n_padding}`}
                                >
                                    info@medallionhomes.com
                                </a>
                                <a
                                    href="tel:+16046179511"
                                    className={`${styles.contact_link} ${styles.zero_margin_n_padding}`}
                                >
                                    (604) 617-9511
                                </a>
                            </Grid2>
                        </Grid2>
                        <Grid2 container spacing={{ xs: 0, md: 3 }} mt={15}>
                            <Grid2 size={{ xs: 12, md: 6 }}>
                                <p
                                    className={`${styles.light_text} ${styles.zero_margin_n_padding}`}
                                >
                                    Address
                                </p>
                            </Grid2>
                            <Grid2 size={{ xs: 12, md: 6 }}>
                                <p
                                    className={`${styles.zero_margin_n_padding}`}
                                >
                                    5594 Fraser St.
                                </p>
                                <p
                                    className={`${styles.zero_margin_n_padding}`}
                                >
                                    Vancouver, BC V5W 2Z4
                                </p>
                            </Grid2>
                        </Grid2>
                    </Grid2>

                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <h3 className="heading_3r">Contact Us</h3>
                        <form onSubmit={handleSubmit}>
                            <Stack spacing={3}>
                                <TextField
                                    fullWidth
                                    label="Name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    variant="outlined"
                                />
                                <TextField
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    variant="outlined"
                                />
                                <TextField
                                    fullWidth
                                    label="Phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    variant="outlined"
                                />
                                <TextField
                                    fullWidth
                                    label="Message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                />
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "black",
                                        color: "white",
                                        "&:hover": {
                                            backgroundColor: "#333",
                                        },
                                    }}
                                >
                                    Send Message
                                </Button>
                            </Stack>
                        </form>
                    </Grid2>
                </Grid2>
            </Container>
        </>
    );
}
